var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99997 10.0001L8.99997 12.0001L13 8.0001M5.83497 2.6971C6.55228 2.63984 7.23325 2.3578 7.78097 1.8911C8.39988 1.36336 9.18662 1.07349 9.99997 1.07349C10.8133 1.07349 11.6001 1.36336 12.219 1.8911C12.7667 2.3578 13.4477 2.63984 14.165 2.6971C14.9757 2.7616 15.737 3.11292 16.312 3.68802C16.8871 4.26312 17.2385 5.02434 17.303 5.8351C17.3602 6.5524 17.6423 7.23338 18.109 7.7811C18.6367 8.40001 18.9266 9.18674 18.9266 10.0001C18.9266 10.8135 18.6367 11.6002 18.109 12.2191C17.6423 12.7668 17.3602 13.4478 17.303 14.1651C17.2385 14.9758 16.8871 15.7371 16.312 16.3122C15.737 16.8873 14.9757 17.2386 14.165 17.3031C13.4477 17.3603 12.7667 17.6424 12.219 18.1091C11.6001 18.6368 10.8133 18.9267 9.99997 18.9267C9.18662 18.9267 8.39988 18.6368 7.78097 18.1091C7.23325 17.6424 6.55228 17.3603 5.83497 17.3031C5.02422 17.2386 4.263 16.8873 3.6879 16.3122C3.1128 15.7371 2.76147 14.9758 2.69697 14.1651C2.63972 13.4478 2.35767 12.7668 1.89097 12.2191C1.36324 11.6002 1.07336 10.8135 1.07336 10.0001C1.07336 9.18674 1.36324 8.40001 1.89097 7.7811C2.35767 7.23338 2.63972 6.5524 2.69697 5.8351C2.76147 5.02434 3.1128 4.26312 3.6879 3.68802C4.263 3.11292 5.02422 2.7616 5.83497 2.6971Z",
    stroke: "#1A4FD6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.79a21031b5bd36e011b79931560b7f95.svg";
export { ForwardRef as ReactComponent };